/**
 * Converts kilograms to pounds.
 * @param {Number} kg
 */
const convertKilogramsToPounds = kg => kg * 2.20462;

export default convertKilogramsToPounds;
